module.exports = __webpack_public_path__ + "img/maps.2e44c2ae.png";